import styled from 'styled-components';

export const StyledShipping = styled.div`
  font-size: ${props => props.theme.fontSizes.small};
  width: 100%;
  padding-top: 15px;

  .item {
    & + .item {
      margin-top: 7px;
    }
  }
`
